import type { i18n } from 'i18next';
import type { TranslationName } from 'types/translator';
import { getCurrentLanguageContent } from 'utils/helios/language';

interface AgendaNameSource {
  translatesDisplayAs?: TranslationName[];
  displayAs?: string;
  name?: string;
}

export const resolveHeliosAgendaName = (i18n: i18n, source?: AgendaNameSource, fallback?: string): string =>
  getCurrentLanguageContent(i18n, source?.translatesDisplayAs) ?? source?.displayAs ?? source?.name ?? fallback ?? '';
